/// <reference path='../../interfaces/interfaces.d.ts' />
import functions = require('../../global/functions')

import {IStateService} from 'angular-ui-router';
import CalendarController from './calendar.controller';

'use strict';

interface IPrivateCalendarScope extends angular.IScope {
    calState: boolean;
}

class PrivateCalendarController extends CalendarController {
    public static $inject = [
        '$scope',
        '$uibModal',
        '$state',
        'User',
        'Calendar',
        'Employee',
        '$timeout',
        'uiCalendarConfig',
        'Orgs',
        'bsLoadingOverlayService'
    ];

    public events = [];
    public eventSources = [this.events];
    public calendarType = '';
    public show_leave = true;
    private state;
    private provisional_event;
    public employee;
    public isTour;

    public monthCounter = 0;
    public currentMonthList = '';
    public showPastEvents = true;

    public calListEvents;
    public isListEvents = true;

    public dayDifference;


    constructor(
                public $scope: IPrivateCalendarScope,
                public $uibModal: any,
                public $state: IStateService,
                public User: IUserService,
                private Calendar: ICalendarService,
                public Employee: IEmpService,
                public $timeout: any,
                public uiCalendarConfig: any,
                public Orgs: IOrgsService,
                private bsLoadingOverlayService: IBsLoadingService) {
        super($uibModal, uiCalendarConfig, $state, Employee, User);
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.state = $state;
        Orgs.getOrgFromCache(org => {
            let workDays = functions.get_work_days(org)
            if (workDays && workDays.length > 1) {
                this.calendarConfig.firstDay = workDays[0];
            }
        });

        $scope.$emit('$pageWithHelpVisited', 0);

        if (this.state.params['provisional_event']) {
            this.provisional_event = this.state.params['provisional_event'];
        }

        this.Employee.loadEmployee(User.getCurrentUser().userData.id).then((response: Restangular.IResponse) => {
            this.isTour = this.Employee.getCoTourStatus();
            let hasVisited: Boolean = false;
            this.employee = response;
            let list: Object[] = this.employee.extra.help_boxes_visited;
            for (let i: number = 0; i < list.length; i++) {
                if (list[i] === 0) {
                    hasVisited = true;
                }
            }
            if (!hasVisited) {
                this.startCallouts();
            } else if (this.isTour === true) {
                this.startCallouts();
            }
        });

        $scope.calState = this.calState;
        let that: any = this;

        $scope.$watch('calState', function(): void {
            if (!$scope.calState) {
                let calendarInstance: any = that.uiCalendarConfig.calendars.currentCalendar;
                if (calendarInstance) {
                    $timeout(function(): void {
                        calendarInstance.fullCalendar('refetchEvents');
                        calendarInstance.fullCalendar('render');
                    }, 0);
                }
            }
        });
    }


    public eventsFetch = (start: moment.Moment, end: moment.Moment, timezone: any, callback: any) => {
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        let that=this;
        this.Calendar.loadEvents(start.unix(), end.unix(), this.calendarType, this.show_leave).then((response: any) => {
            let events: any[] = [];
            that.bsLoadingOverlayService.stop({referenceId: 'loader'});
            response.forEach((event: any) => {
                let eventType: string = 'default';
                if (event.event_type) {
                    eventType = event.event_type;
                }
                // convert start and end dates to moment
                event.start = moment(event.start);
                let addEndTime: boolean = event.end.length === 10;
                if (addEndTime) {
                    event.end = moment(event.end + ' 23:59:59');
                } else {
                    event.end = moment(event.end);
                }
                // calculate event specific properties
                const dura: any = moment.duration(event.end.diff(event.start));
                const hrs: any = Math.round(dura.asHours());
                event.tempObj = {
                    allDay: '',
                    multiDay: '',
                    eventIsPast: false,
                    dayDifference: '',
                };
                // check if the event is happening for the entire day or more
                if (hrs > 24) {
                    event.tempObj.allDay = true;
                    event.tempObj.multiDay = false;
                    if (event.end.isAfter(event.start, 'day')) {
                        let start_dt: any = moment.utc(event.start);
                        start_dt.startOf('day');
                        let end_dt: any = moment.utc(event.end);
                        end_dt.startOf('day');
                        this.dayDifference = end_dt.diff(start_dt, 'days');
                        event.tempObj.allDay = true;
                        event.tempObj.multiDay = true;
                    }
                } else if (hrs === 24) {
                    event.tempObj.allDay = true;
                    event.tempObj.multiDay = false;
                } else {
                    event.tempObj.allDay = false;
                    event.tempObj.multiDay = false;
                }

                // add colour attribute based on whether the event is an all day event or not.
                event.color = this.getColor(eventType);
                event.bulletColor = event.color;

                let isAllOrMultiDay: boolean = event.tempObj.allDay ||  event.tempObj.multiDay;
                if (!isAllOrMultiDay) {
                    event.color = 'rgba(0, 0, 0, 0)';
                }
                event.tempObj.dayDifference = this.dayDifference;
                let eveOverToday: Boolean = moment().isBefore(event.end, 'minute');
                if (eveOverToday === false) {
                    event.tempObj.eventIsPast = false;
                } else if (eveOverToday) {
                    event.tempObj.eventIsPast = true;
                }
                events.push(event);
            });

            // check if there is a provision event to load from the scope (like from the ProcessDetail page
            if (this.provisional_event) {
                events.push(this.provisional_event);
                this.gotoDate(this.provisional_event.start);
            }

            this.calListEvents = events;
            if (this.calListEvents.length <= 0) {
                this.isListEvents = false;
            } else {
                this.isListEvents = true;
            }
            callback(events);
        });
    }

    /**
     * Switch month
     * @param direct {string} - prev | next
     */
    public changeMonth(direct: string): void {
        this.uiCalendarConfig.calendars.currentCalendar.fullCalendar(direct);
    }

    public changeViewType(type: string): void {
        this.uiCalendarConfig.calendars.currentCalendar.fullCalendar('changeView', type);
    }

    public gotoDate(to_date: string): void {
        this.uiCalendarConfig.calendars.currentCalendar.fullCalendar('gotoDate', to_date );
    }

    public changeMonthList(direction: string): void {
        this.uiCalendarConfig.calendars.currentCalendar.fullCalendar(direction);
        // fixme: This is a workaround for a bug in the fullCalendar.  It will retrieve events from the
        //  new date, i.e. the date after the next/prev is called.  Without the next few lines, the refetch
        //  will fetch events for the old date.
        let newDate: any = this.uiCalendarConfig.calendars.currentCalendar.fullCalendar('getDate');
        let view: any = this.uiCalendarConfig.calendars.currentCalendar.fullCalendar('getView');
        view.display(newDate);
        this.uiCalendarConfig.calendars.currentCalendar.fullCalendar('refetchEvents');
    }

    public changeView(): any {
        if (this.calState) {
            this.calLabel = 'List View';
            this.$scope.$emit('$EL', 'calendar.list_view');
        } else {
            this.calLabel = 'Calendar View';
            this.$scope.$emit('$EL', 'calendar.cal_view');
        }
        this.$scope.calState = this.calState;
    }

    public showPastEventsToggle(): void {
        this.showPastEvents = !this.showPastEvents;
    }

    public hasTeam = () => {
        return this.User.getCurrentUser().userData.subordinates 
        ? this.User.getCurrentUser().userData.subordinates.length > 0 
        : false;
    }

    public hasSuperiors = () => {
        return this.User.getCurrentUser().userData.all_superiors 
        ? this.User.getCurrentUser().userData.all_superiors.length > 0 
        : false;
    }

    public changeShowLeave = () => {
        this.show_leave = !this.show_leave;
        this.uiCalendarConfig.calendars.currentCalendar.fullCalendar('refetchEvents');
    }

    public changeListFilters = (label: any): void => {
        if (label === 'Past Items') {
            this.showPastEventsToggle();
        }
        this.Calendar.updateEventFilters(this.calListFilters);
        this.uiCalendarConfig.calendars.currentCalendar.fullCalendar('refetchEvents');
    }

    public changeCalendarType = (calendar_type: any): void => {
        this.calendarType = calendar_type;
        this.uiCalendarConfig.calendars.currentCalendar.fullCalendar('refetchEvents');
    }

    public calendarConfig = {
        contentHeight: 800,
        dayClick: this.clickOnDay,
        editable: false,
        eventClick: this.clickOnEvent,
        header: {
            center: '',
            left: '',
            right: ''
        },
        eventLimit: true,
        views: {
            agenda: {
                eventLimit: 1
            }
        },
        events: this.eventsFetch,
        viewRender: this.viewRender,
        eventRender: this.eventRender,
        dayRender: this.dayRender,
        firstDay: 0
    };

    public nextTour = () => {
        this.$state.go('root.processes');
    }
}

angular.module('beneple.calendar').controller('PrivateCalendarController', PrivateCalendarController);



// WEBPACK FOOTER //
// ./frontend/scripts/calendar/controllers/private_calendar.controller.ts